import React, { useEffect, useState, useRef } from 'react'
import { useQuery, useMutation } from 'react-query'
import { useHistory, useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { formatFormData, getData } from 'common/utils'
import { toast } from 'react-toastify'
import Row from 'components/ui/Row'
import Col from 'components/ui/Col'
import { Editor } from '@tinymce/tinymce-react'
import TextField from 'components/form/TextField'
import Checkbox from 'components/form/Checkbox'
import Button from 'components/form/Button'
import Overlay from 'components/ui/Overlay'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'

const StaticPageForm = (props) => {
  const history = useHistory()
  const editorRef = useRef(null)
  const { id } = useParams()
  const { handleSubmit, control, setValue, formState: { errors }, setError } = useForm()

  const [isLoading, setIsLoading] = useState(false)

  const [content, setContent] = useState('')

  const { data: dataInfo } = useQuery(['getInfoStaticPage', id], async () => {
    if (id) {
      return await getData('GET', `static_page/${id}/`)
    }
  })

  const mutation = useMutation(async (dataForm) => {
    if (dataForm) {
      if (id) {
        return await getData('PUT', `static_page/${id}/`, dataForm)
      } else {
        return await getData('POST', 'static_page/', dataForm)
      }
    }
  })

  useEffect(() => {
    setIsLoading(true)
  }, [])

  useEffect(() => {
    if (dataInfo) {
      const resultData = dataInfo.data

      if (resultData) {
        setValue('title', resultData.title)
        setValue('slug', resultData.slug)
        setValue('is_active', resultData.is_active)

        setContent(resultData.content)
      }
    }
  }, [dataInfo])

  /* ----------------------------------------------- */
  /* --------------- Handle Event ------------------ */
  /* ----------------------------------------------- */
  const onSubmit = async (data) => {
    try {
      if (id) {
        await mutation.mutateAsync({
          title: formatFormData(data.title),
          slug: formatFormData(data.slug),
          content: editorRef.current.getContent(),
          is_active: typeof data.is_active === 'undefined' ? true : data.is_active
        })
      } else {
        await mutation.mutateAsync({
          title: formatFormData(data.title),
          slug: formatFormData(data.slug),
          content: editorRef.current.getContent(),
          is_active: typeof data.is_active === 'undefined' ? true : data.is_active,
          tenant: localStorage.getItem('tenant')
        })
      }
      history.goBack()
    } catch (err) {
      if (err.response && err.response.status === 400) {
        const errData = err.response.data && err.response.data.errors
        if (typeof errData === 'object') {
          console.log(errData)
          for (const item in errData) {
            const errItemArr = errData[item]
            setError(item, {
              type: 'manual',
              message: Array.isArray(errItemArr) && errItemArr[0]
            })

            if (Array.isArray(errItemArr)) {
              toast.error(errItemArr[0])
            }
          }
        }
      } else {
        toast.error('Something went wrong!')
      }
      console.log(err)
    }
  }

  const handleCancel = () => {
    history.goBack()
  }

  return (
    <div className="static-page-form">
      <Card>
        <CardContent>
          <Row className="pt-3">
            <Col md={4}>
              <TextField label="Title" name="title" required control={control} error={errors.title} />
            </Col>
            <Col md={4}>
              <TextField label="Slug" name="slug" required control={control} error={errors.slug} />
            </Col>
            <Col md={4}>
              <Checkbox name="is_active" control={control} defaultChecked label="Active" />
            </Col>
          </Row>
          <Row className="pt-4">
            <Col md={12}>
              <Editor
                apiKey='8xwdiofw91cl5ikp80dpkij70sj7u8uziroarh8v1420aq6y'
                tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                // eslint-disable-next-line no-return-assign
                onInit={(evt, editor) => {
                  editorRef.current = editor
                  setIsLoading(false)
                }}
                initialValue={content}
                init={{
                  height: 550,
                  branding: false,
                  plugins: 'advlist autolink lists link charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime table code help wordcount',
                  toolbar: 'undo redo | formatselect | ' +
                    'bold italic backcolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
              />
            </Col>
          </Row>
        </CardContent>
        <CardActions className="card-action-mui">
          <Button className="mr-2 d-inline-block" color="error" onClick={handleCancel}>Cancel</Button>
          <Button className="mr-2 d-inline-block" onClick={handleSubmit(onSubmit)}>Save</Button>
        </CardActions>
      </Card>

      {isLoading && <Overlay />}
    </div>
  )
}

export default StaticPageForm
